import DateDisplay from 'components/DateDisplay';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the documentValidUntil.
 */
export default function DocumentValidUntilColumn({
  data: { documentValidUntil, revisionStatus },
}: {
  data: RevisionRow;
}) {
  return documentValidUntil ? <DateDisplay date={new Date(documentValidUntil)} withRelative={false} /> : '';
}
